/******
	デバイス判別（matchMediaベース）
*******/
const _ua = {
  TB: window.matchMedia('(max-width: 1023px) and (min-width: 768px), (max-device-width: 1366px) and (orientation: portrait)').matches,
  SP: window.matchMedia('(max-width: 767px)').matches
};


/******
	ブレイクポイント判別（matchMediaベース）
*******/
const _breakP = {
  PC: window.matchMedia('(min-width: 1024px)').matches,
  TB: window.matchMedia('(max-width: 1023px) and (min-width: 768px)').matches,
  SP: window.matchMedia('(max-width: 767px)').matches
};

/******
	ログ出力
*******/
const _log = (_key, _value, _color) => {
  if (location.href.indexOf('localhost') > 0) {
    console.log(
      `%c${_key}%c${_value}`,
      `margin-right: 10px; padding: 3px 5px; background: ${_color}; color: #fff;`,
      '',
      '',
      ''
    );
  } else {
    return null;
  }
};

export { _ua, _breakP, _log };
